import { TileCornerBuildingType, TileHexType } from '@colonist/game-states';
export class MechanicValidatorMerchant {
    whereCanPlayerPlaceMerchant(playerMovingMerchant) {
        const whereCanPlayerPlaceMerchant = [];
        const validBuildingTypes = [
            TileCornerBuildingType.Settlement,
            TileCornerBuildingType.City,
            TileCornerBuildingType.DestroyedCity
        ];
        for (const tileCorner of this.mapValidator.tileState.tileCorners){
            if (tileCorner.owner != playerMovingMerchant) continue;
            if (tileCorner.buildingType == undefined) continue;
            if (!validBuildingTypes.includes(tileCorner.buildingType)) continue;
            for (const touchingFace of tileCorner.hexCorner.touchingFaces()){
                const tileIndex = this.mapValidator.tileState.getTileHexIndex(touchingFace);
                if (tileIndex == undefined) continue;
                if (whereCanPlayerPlaceMerchant.includes(tileIndex)) continue;
                const tileHex = this.mapValidator.tileState.tiles[tileIndex];
                if (!MechanicValidatorMerchant.canMerchantBePlacedOnTileOfType(tileHex.tileType)) continue;
                whereCanPlayerPlaceMerchant.push(tileIndex);
            }
        }
        return whereCanPlayerPlaceMerchant;
    }
    static canMerchantBePlacedOnTileOfType(tileType) {
        switch(tileType){
            case TileHexType.Lumber:
            case TileHexType.Brick:
            case TileHexType.Wool:
            case TileHexType.Grain:
            case TileHexType.Ore:
                return true;
            case TileHexType.Sea:
            case TileHexType.Gold:
            case TileHexType.Desert:
            case TileHexType.Fog:
                return false;
        }
    }
    constructor(mapValidator, merchantState){
        this.mapValidator = mapValidator;
        this.merchantState = merchantState;
    }
}
